"use client";
import { useEffect, useState } from "react";
import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";
import { Link } from "@/navigation";

function Navbar() {
    return (
        <nav className="sticky top-0 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-50">
            <div className="max-w-7xl mx-auto px-4 py-0 md:py-3">
                <div className="flex items-center justify-between w-full h-16">
                    <Link href="/" className="w-24">
                        <img 
                            className="w-full h-full object-cover" 
                            src="/logos/logo.webp" 
                            alt="Dr and Coach" 
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden lg:block w-3/4">
                        <DesktopNavbar />
                    </div>

                    {/* Mobile Navigation */}
                    <div className="lg:hidden">
                        <MobileNavbar />
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;